import Logger from '../fw/logger';
import Env from '../fw/env';


export default class ViewableObserver {

  #rmp;
  #viewablePreviousRatio = 0.5;
  #viewableObserver = null;
  #playerVisible = false;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get playerVisible() {
    return this.#playerVisible;
  }

  #handleViewIntersect(entries) {
    entries.forEach(entry => {
      const playerInitialized = this.#rmp.rmpPlaybackManagement.playerInitialized;
      if (entry.intersectionRatio > this.#viewablePreviousRatio) {
        if (this.#rmp.viewableAutoplay) {
          this.#rmp.play().catch(error => {
            this.#rmp.rmpUtils.warning(1014, error);
          });
        }
        if (!this.#rmp.viewablePlayPause && !playerInitialized) {
          try {
            this.#viewableObserver.disconnect();
          } catch (warning) {
            console.warn(warning);
          }
        }
        this.#playerVisible = true;
        this.#rmp.dispatch('playerinview');
      } else {
        if (this.#rmp.viewablePlayPause && playerInitialized) {
          this.#rmp.pause();
        }
        this.#playerVisible = false;
        this.#rmp.dispatch('playeroutofview');
      }
      this.#viewablePreviousRatio = entry.intersectionRatio;
    });
  }

  #attachViewableObserver() {
    Logger.print('IntersectionObserver', 'attach viewable observer as player is now ready');
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [this.#rmp.viewableThreshold],
    };
    this.#viewablePreviousRatio = this.#rmp.viewableThreshold;
    this.#viewableObserver = new IntersectionObserver(this.#handleViewIntersect.bind(this), options);
    this.#viewableObserver.observe(this.#rmp.dom.container);
  }

  destroy() {
    Logger.print('IntersectionObserver', 'destroy viewable observer');
    try {
      this.#viewableObserver.disconnect();
    } catch (warning) {
      console.warn(warning);
    }
  }

  init() {
    this.#rmp.one('ready', this.#attachViewableObserver.bind(this));
    if (Env.isIos[0]) {
      this.#rmp.dom.video.addEventListener('webkitbeginfullscreen', () => {
        this.destroy();
      });
      this.#rmp.dom.video.addEventListener('webkitendfullscreen', () => {
        this.#attachViewableObserver();
      });
    }
  }

}
